import { ShopwareMessageTypePrivileges } from '.';
import { adminExtensions } from '../channel';
export function sendPrivileged(messageType) {
    const requiredPrivileges = getRequiredPrivilegesForMessage(messageType);
    const locationPrivileges = getLocationPrivileges(window.location);
    if (!requiredPrivileges || Object.keys(requiredPrivileges).length <= 0) {
        return null;
    }
    return getMissingPrivileges(requiredPrivileges, locationPrivileges);
}
export function handlePrivileged(messageType, origin) {
    const requiredPrivileges = getRequiredPrivilegesForMessage(messageType);
    const extension = findExtensionByBaseUrl(origin);
    if (!extension) {
        return null;
    }
    return getMissingPrivileges(requiredPrivileges, extension.permissions);
}
function getRequiredPrivilegesForMessage(messageType) {
    var _a;
    return (_a = ShopwareMessageTypePrivileges[messageType]) !== null && _a !== void 0 ? _a : {};
}
function getLocationPrivileges(location) {
    const params = new URLSearchParams(location.search);
    const privilegeString = params.get('privileges');
    if (!privilegeString) {
        return {};
    }
    return JSON.parse(privilegeString);
}
function getMissingPrivileges(requiredPrivileges, privileges) {
    const requiredRoles = Object.keys(requiredPrivileges);
    const missingPriviliges = [];
    // Compare detailed priviliges of each role and add missing to stack
    requiredRoles.forEach((requiredRole) => {
        var _a;
        (_a = requiredPrivileges[requiredRole]) === null || _a === void 0 ? void 0 : _a.forEach((privilege) => {
            var _a;
            if (!((_a = privileges[requiredRole]) === null || _a === void 0 ? void 0 : _a.includes(privilege))) {
                missingPriviliges.push(`${requiredRole}:${privilege}`);
            }
        });
    });
    return missingPriviliges.length >= 1 ? missingPriviliges : null;
}
export function findExtensionByBaseUrl(baseUrl) {
    if (typeof baseUrl !== 'string') {
        return undefined;
    }
    if (baseUrl === '') {
        return undefined;
    }
    const comparedBaseUrl = new URL(baseUrl);
    /*
     * Check if baseUrl is the same as the current window location
     * If so, return the dummy extension with all privileges available
     */
    if (comparedBaseUrl.origin === window.location.origin) {
        return {
            baseUrl: comparedBaseUrl.hostname,
            permissions: {
                additional: ['*'],
                create: ['*'],
                read: ['*'],
                update: ['*'],
                delete: ['*'],
            },
        };
    }
    return Object.values(adminExtensions)
        .find((ext) => {
        const extensionBaseUrl = new URL(ext.baseUrl);
        return extensionBaseUrl.hostname === comparedBaseUrl.hostname;
    });
}
//# sourceMappingURL=privilege-resolver.js.map